
import React, { useState } from "react";
import { Form, Button, Card, Row, Col } from "react-bootstrap";
import "../css/main.css";

const ISLFileUploadForm = ({
  handleSubmit,
  handleYoutubeISLSubmit,
  file,
  fileError,
  dragging,
  setDragging,
  handleDrop,
  handleFileChange,
setFile,
  mediaTitle,
  setMediaTitle,
  mediaTitleError,
  setMediaTitleError,
  mediaDescription,
  setMediaDescription,
  mediaDescriptionError,
  setMediaDescriptionError,
  mediaNarrator,
  setMediaNarrator,

  youtubeUrl,
  setYoutubeUrl,
  youtubeUrlError,
  setYoutubeUrlError,
  ytTitle,
  ytTitleError,
  setYtTitle,
  setYtTitleError,
  ytDescription,
  ytDescriptionError,
  setYtDescription,
  setYtDescriptionError,
  ytNarrator,
  setYtNarrator,
  isldashboardData
}) => {
  const [activeSection, setActiveSection] = useState("media");

  return (
   <Card className="p-3 shadow-sm border-1 leftform-card"  role="region"
     aria-labelledby="generatorHeading">
      <h5 id="generatorHeading"
 className="mb-2 fw-bold" style={{ color: "#B0004E" }}>
Accessible ISL Video Description Generator
      </h5>

      {/* Tabs */}
     <div
  role="tablist"
  aria-label="Upload options"
  className="d-flex justify-content-center border-bottom mb-3"
  style={{ gap: "1rem", fontWeight: "500", fontSize: "0.95rem" }}
>         <div
          role="tab"
          tabIndex={0}
              id="tab-media"
          aria-selected={activeSection === "media"}
          aria-controls="mediaPanel"
          className={`me-4 pb-2 fw-semibold ${
            activeSection === "media"
              ? "text-dark border-bottom border-3 border-primary"
              : "text-muted"
          }`}
          style={{ cursor: "pointer" }}
       //   onClick={() => setActiveSection("media")}
onClick={() => {
  setActiveSection("media");
  setYoutubeUrl("");
  setYtTitle("");
  setYtDescription("");
}}


          
          onKeyDown={(e) => e.key === "Enter" && setActiveSection("media")}
        >
1. Upload Video
        </div>

       <div
          role="tab"
          tabIndex={0}
              id="tab-youtube"

          aria-selected={activeSection === "youtube"}
          aria-controls="youtubePanel"
          
          className={`pb-2 fw-semibold ${
            activeSection === "youtube"
              ? "text-dark border-bottom border-3 border-primary"
              : "text-muted"
          }`}
          style={{ cursor: "pointer" }}
        //  onClick={() => setActiveSection("youtube")}
        onClick={() => {
  setActiveSection("youtube");
  setFile(null);
  setMediaTitle("");
  setMediaDescription("");
}}

          onKeyDown={(e) => e.key === "Enter" && setActiveSection("youtube")}
        >
       2. YouTube Link
        </div>
      </div>

      {/* ================= MEDIA TAB ================= */}
      {activeSection === "media" && (
        <>
                             <div
  role="button"
  aria-label="Upload a media file. Press Enter to browse files."
  
  aria-describedby="fileHelp"
  aria-invalid={fileError}
  tabIndex={0}
  className={`upload-dropzone text-center ${
    dragging ? "drag-active" : ""
  } ${fileError ? "error-border" : ""}`}
  onDragOver={(e) => {
    e.preventDefault();
    setDragging(true);
  }}
  onDragLeave={() => setDragging(false)}
  onDrop={handleDrop}
  onClick={() => document.getElementById("fileInput").click()}
  onKeyDown={(e) =>
    e.key === "Enter" && document.getElementById("fileInput").click()
  }
>
   <i
              className="bi bi-cloud-arrow-up"
              style={{ fontSize: "1.9rem", color: "rgb(176, 0, 78)" }}
            ></i>
                      <p
  className="mb-2 fw-bold"
  style={{
    fontSize: "0.9rem",
    color: "rgb(176, 0, 78)",
    maxWidth: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  }}
  title={file ? file.name : ""}   // hover shows full name
>
  {file ? file.name : "Drag and Drop or Click to Upload Video File"}
</p>


   {!file && (
              <p
                id="fileHelp"
                className="mb-2 fw-semibold"
                style={{ fontSize: "0.9rem" }}
              >
                MP4, MOV, WEBM, M4V, MKV
              </p>
            )}

             <Form.Control
                        id="fileInput"
                        type="file"
                        accept=".mp4,.mov,.webm,.m4v,.mkv"
                        aria-hidden="true"
                        tabIndex={-1}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />
          </div>

          {fileError && (
          
             <span
                className="invalid-feedback d-block  text-danger fw-semibold"
                role="alert"
                aria-live="assertive"
              >
              Please upload a valid video file.
            </span>
          )}

          <Form>
           <Form.Group className="my-2" style={{ display: "none" }}>
 <label htmlFor="mediaTitle">Video Title</label>
         <Form.Control
               id="mediaTitle"
      type="text"
      placeholder="Enter Video Title"
      value={mediaTitle}
      aria-invalid={mediaTitleError}
        aria-describedby={mediaTitleError ? "titleError" : undefined}
      onChange={(e) => {
        setMediaTitle(e.target.value);
        if (e.target.value.trim()) setMediaTitleError(false);
      }}
    />
            </Form.Group>

                 <Form.Group className="my-2" style={{ display: "none" }}>
            <label htmlFor="mediaDescription">Video Description</label>
              <Form.Control
                          as="textarea"
                          rows={2}
                          aria-label="Video description"
                          style={{ height: "30px" }}
                          id="mediaDescription"
                          placeholder="Enter Video Description"
                          value={mediaDescription}
                          aria-invalid={mediaDescriptionError}
                          onChange={(e) => {
                            setMediaDescription(e.target.value);
                            if (e.target.value.trim()) setMediaDescriptionError(false);
                          }}
                        />
            </Form.Group>

                 <Form.Group className="my-2">
             <label htmlFor="mediaNarrator">ISL Interperter</label>
             <Form.Select
                           aria-label="Narrator"
           
               id="mediaNarrator"
               value={mediaNarrator}
               onChange={(e) => setMediaNarrator(e.target.value)}
             >
               {/* <option value="">Select Narrator</option> */}
           
               {isldashboardData?.data?.form_data?.model_choices?.map((item, idx) => (
                 <option key={idx} value={item.key}>
                   {item.label}
                 </option>
               ))}
             </Form.Select>
           </Form.Group>
     <div className="mt-4">
  <Button
    className="fileupload-submit-btn submit-btn-custom w-100 "
 onClick={() => handleSubmit()}
     aria-label="Submit Upload Form"
     
  >
   Start Generation
  </Button>
</div>
          </Form>
        </>
      )}

      {/* ================= YOUTUBE TAB ================= */}
      {activeSection === "youtube" && (
        <>
        <Row className="mb-3" role="tabpanel" id="youtubePanel">
          <Col md={12}>
              <Form.Group>
                            <label htmlFor="youtubeUrlInput">YouTube URL</label>
                            <Form.Control
                              id="youtubeUrlInput"
                              type="url"
                              placeholder="Enter YouTube URL"
                              value={youtubeUrl}
                              aria-invalid={youtubeUrlError}
                              aria-describedby={youtubeUrlError ? "ytError" : null}
                              onChange={(e) => {
                                setYoutubeUrl(e.target.value);
                                if (e.target.value.trim()) setYoutubeUrlError(false);
                              }}
                            />
                            {youtubeUrlError && (
                              <span
                                id="ytError"
                                role="alert"
                                className="invalid-feedback d-block text-danger fw-semibold"
                              >
                                Please enter a valid YouTube link.
                              </span>
                            )}
                          </Form.Group>
            </Col>
          </Row>

          <Form>
            <Form.Group className="my-2" style={{ display: "none" }}>
              <label htmlFor="ytTitle">Video Title</label>
                  <Form.Control
                        id="ytTitle"
               type="text"
               placeholder="Enter Video Title"
               value={ytTitle}
               onChange={(e) => {
                 setYtTitle(e.target.value);
                 if (e.target.value.trim()) setYtTitleError(false);
               }}
             />
            </Form.Group>

            <Form.Group className="my-2" style={{ display: "none" }}>
              <label htmlFor="ytDescription">Video Description</label>
             <Form.Control
                         as="textarea"
                         rows={2}
                         aria-label="Video description"
                         style={{ height: "30px" }}
                         id="ytDescription"
                         placeholder="Enter Video Description"
                         value={ytDescription}
                         aria-invalid={ytDescriptionError}
                         onChange={(e) => {
                           setYtDescription(e.target.value);
                           if (e.target.value.trim()) setYtDescriptionError(false);
                         }}
                       />
            </Form.Group>

 <Form.Group className="my-2">
  <label htmlFor="ytNarrator">ISL Interperter</label>
             <Form.Select
                             aria-label="Narrator"
             
                 id="ytNarrator"
                 value={ytNarrator}
                 onChange={(e) => setYtNarrator(e.target.value)}
               >
             
                 {isldashboardData?.data?.form_data?.model_choices?.map((item, idx) => (
                   <option key={idx} value={item.key}>
                     {item.label}
                   </option>
                 ))}
               </Form.Select>
            </Form.Group>

                  <div className="mt-4">
              <Button
                className="fileupload-submit-btn submit-btn-custom w-100 "
             onClick={() => handleYoutubeISLSubmit()}
                 aria-label="Submit Upload Form"
                 
              >
               Start Generation
              </Button>
            </div>
          </Form>
        </>
      )}
    </Card>
  );
};

export default ISLFileUploadForm;
